<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                @dblclick:row="rowClick"
                class="elevation-1 customization-list-table pagination-list-table sticky-table">

                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.document_type`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.document_type">
                                {{ item.document_type }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.template_name`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.template_name">
                                {{ item.template_name }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>
</template>

<script>
import { mapActions } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";

export default {
    columnIndex:  {
        'document_type': 2,
        'template_name': 3
    },
    props: {
        search: {
            type: String,
            default: ""
        }
    },
    computed: {
        collection() {
            return this.$store.getters['templates/getCollection'];
        },
        headers() {
            return [
                { text: this.$t("Тип"), value: 'document_type', width: '150px' },
                { text: this.$t("Наименование"), value: 'template_name' }
            ];
        },
        options: {
            get: function() {
                let op = this.$store.getters['templates/templates/getTableOptions'];
                return op;
            },
            set: function(newValue) {
                this.$store.commit('templates/templates/SET_TABLE_OPTION', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        resetPage() {
            this.$store.commit('templates/templates/SET_TABLE_OPTION_PAGE', 1);
        },
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getSerializedFilter()))
                return;

            this.prevTableFilterObject = this.getSerializedFilter();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/templates/list?collection=${this.collection}&filter=${this.getSerializedFilter()}`,
                method: 'GET',
                headers: { "isCommon": true }
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "template_name" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 3;

            return JSON.stringify({ 
                SearchStr,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            });
        },
        async rowClick(e, row) {
            this.setOverlayVisible({ visible: true });
            await this.$router.push({ name: 'TemplateCard', query: { id: row.item.id }, params: { id: row.item.id }});
            this.setOverlayVisible({ visible: false });
        }
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    },
}
</script>
